import React, { useEffect, useState } from "react";
import Modal from "../../Components/Layout/Modal";
import { Button } from "primereact/button";
import { toastError, toastSuccess } from "../../Components/Toasts/Toast";
import { useSelector } from "react-redux";

const ProductUspHighlight = ({
  filesUps,
  filesDescsUps,
  filesDescsUpss,
  productDetail,
  productDetails,
  productUps,
  productUpss,
  numRowsUps,
  onDetailChangeTextUps,
  removeRowUps,
  addRowUps,
  onUpsSave,
  onFileChangeImageUps,
  onRemoveFileImageUps,
  setState,
  wrapStyle,
  onAddFileDescImageUps,
  resetRowUsp,
  removeRowUsp,
  modalId5,
  onCloseModal5,
  fileSelectedUps,
  media_types,
  content_types,
  onAddFileDescModalUsp,
  onDescChangeUsp,
  approval_status,
  next_step_nik_detail,
  is_draft_saved,
}) => {
  console.log(is_draft_saved);
  let { userInfo } = useSelector((state) => state.auth);
  return (
    <div>
      {productUps &&
        productUps.length > 0 &&
        productUps?.map((item, index) => {
          return (
            <div key={index}>
              <div
                className="row"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "left",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <div className="card col-md-2" style={{ margin: "30px" }}>
                  <div className="card-header">
                    <div className="card-title" style={{ width: "100%" }}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        <div>USP Product Highlight</div>
                      </div>
                    </div>
                  </div>
                  <div key={"card" + index}>
                    <div className="card-body">
                      <div className="form-group">
                        <div
                          className="d-flex"
                          style={{
                            margin: "16px 0",
                            flexFlow: "wrap",
                            padding: 10,
                          }}
                        >
                          <div
                            key={"key_file_" + index}
                            style={{ display: "flex" }}
                          >
                            {
                              <div style={wrapStyle}>
                                {/* <div style={{ position: 'absolute', right: -10, top: -10 }}>
                                                                    <Button type='button' className='p-button-rounded p-button-danger' icon="pi pi-times" style={{ width: 30, height: 30 }} onClick={onRemoveFileImageUps(item.productUps, index)} />
                                                                </div> */}
                                {
                                  item.file_path && (
                                    <img
                                      src={item.file_path}
                                      style={{
                                        objectFit: "cover",
                                        width: "100%",
                                        height: "100%",
                                        borderRadius: 4,
                                        marginBottom: 20,
                                        cursor: "pointer",
                                      }}
                                      onClick={() =>
                                        onAddFileDescImageUps(item, index)
                                      }
                                    />
                                  )
                                  // :
                                  // <img src={URL.createObjectURL(item)} style={{ objectFit: 'cover', width: '100%', height: '100%', borderRadius: 4, marginBottom: 20, cursor: 'pointer' }} onClick={() => onAddFileDescImageUps(item, index)} />
                                }
                              </div>
                            }
                            {item.media_type.isArray ? (
                              (item.media_type.length > 0 || item.content_type.length > 0) &&
                              (
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "flex-start",
                                    alignItems: "center",
                                    marginRight: 10,
                                  }}
                                >
                                  <div style={{ width: 85, marginTop: 15 }}>
                                    {item.media_type?.map((items, i) => {
                                      if (i < 2) {
                                        return (
                                          <p
                                            key={"media_" + i}
                                            style={{
                                              fontSize: 12,
                                              marginTop: -15,
                                              backgroundColor: "#ffe99b",
                                              paddingLeft: 2,
                                              borderRadius: 5,
                                              color: "#000",
                                            }}
                                          >
                                            {items}
                                          </p>
                                        );
                                      }
                                    })}
                                    {item.media_type.length - 2 > 0 && (
                                      <p
                                        style={{
                                          fontSize: 12,
                                          marginTop: -15,
                                          backgroundColor: "#ffe99b",
                                          paddingLeft: 2,
                                          borderRadius: 5,
                                          width: 35,
                                          color: "#000",
                                        }}
                                      >
                                        {item.media_type.length - 2}+
                                      </p>
                                    )}
                                  </div>

                                  <div style={{ width: 85, marginTop: 5 }}>
                                    {item.content_type.map((items, i) => {
                                      if (i < 2) {
                                        return (
                                          <p
                                            key={"content_" + i}
                                            style={{
                                              fontSize: 12,
                                              marginTop: -15,
                                              backgroundColor: "#ffe99b",
                                              paddingLeft: 2,
                                              borderRadius: 5,
                                              color: "#000",
                                            }}
                                          >
                                            {items}
                                          </p>
                                        );
                                      }
                                    })}
                                    {item.content_type.length - 2 > 0 && (
                                      <p
                                        style={{
                                          fontSize: 12,
                                          marginTop: -15,
                                          backgroundColor: "#ffe99b",
                                          paddingLeft: 2,
                                          borderRadius: 5,
                                          width: 35,
                                          color: "#000",
                                        }}
                                      >
                                        {item.content_type.length - 2}+
                                      </p>
                                    )}
                                  </div>
                                </div>
                              )
                            ) : (
                              <div>
                                <div style={{ width: 85, marginTop: 15 }}>
                                  {
                                    <p
                                      style={{
                                        fontSize: 12,
                                        marginTop: -15,
                                        backgroundColor: "#ffe99b",
                                        paddingLeft: 2,
                                        borderRadius: 5,
                                        color: "#000",
                                      }}
                                    >
                                      {item.media_type}
                                    </p>
                                  }
                                  {
                                    <p
                                      style={{
                                        fontSize: 12,
                                        marginTop: -15,
                                        backgroundColor: "#ffe99b",
                                        paddingLeft: 2,
                                        borderRadius: 5,
                                        color: "#000",
                                      }}
                                    >
                                      {item.content_type}
                                    </p>
                                  }
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      {
                        productDetail && (
                          <div>
                            <input
                              id={"file-image-usp-" + index}
                              className="d-none"
                              type="file"
                              accept="image/png, image/jpg, image/jpeg"
                              onChange={(e) => onFileChangeImageUps(e, index)}
                            />
                            <a
                              type="button"
                              className={
                                productDetail?.language_code &&
                                  (!approval_status ||
                                    approval_status == "NOT SUBMITTED" ||
                                    approval_status == "REJECTED" ||
                                    approval_status == "COMPLETED" ||
                                    (approval_status == "ONREVISED" &&
                                      next_step_nik_detail == userInfo.nik))
                                  ? "btn btn-outline-warning"
                                  : "mati btn btn-outline-warning"
                              }
                              style={{ width: 120 }}
                              onClick={() => {
                                window.$("#file-image-usp-" + index).click();
                              }}
                            >
                              <i className="fa fa-image" /> Choose{" "}
                            </a>
                          </div>
                        )
                        // :
                        // ''
                      }
                    </div>
                  </div>
                </div>
                {item.tags && productDetail && item.tags.filter(
                  (i) => i.language_code == productDetail?.language_code
                )
                  .map((items, i) => (
                    <div
                      key={i}
                      style={{
                        display: "flex",
                        alignContent: "left!important",
                        flexDirection: "row",
                        width: "70%",
                      }}
                    >
                      <div className="col-md-3">
                        <div
                          className="form-group"
                          style={{ paddingInlineStart: "10px" }}
                        >
                          <label htmlFor="title">Title</label>
                          <textarea
                            style={{ resize: "none", whiteSpace: "pre-wrap" }}
                            id="title"
                            maxLength={200}
                            name="title"
                            className="form-control"
                            rows={2}
                            disabled={
                              approval_status == "ONPROGRESS" ||
                              (approval_status == "ONREVISED" &&
                                next_step_nik_detail != userInfo.nik)
                            }
                            onChange={(e) =>
                              onDetailChangeTextUps(
                                e,
                                index,
                                productUps[index].tags.findIndex(
                                  (e) =>
                                    e.language_code ==
                                    productDetail?.language_code
                                )
                              )
                            }
                            value={items.title}
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div
                          className="form-group"
                          style={{ paddingInlineStart: "10px" }}
                        >
                          <label htmlFor="description">Description</label>
                          <textarea
                            style={{ resize: "none", whiteSpace: "pre-wrap" }}
                            id="description"
                            maxLength={200}
                            name="description"
                            className="form-control"
                            rows={2}
                            disabled={
                              approval_status == "ONPROGRESS" ||
                              (approval_status == "ONREVISED" &&
                                next_step_nik_detail != userInfo.nik)
                            }
                            onChange={(e) =>
                              onDetailChangeTextUps(
                                e,
                                index,
                                productUps[index].tags.findIndex(
                                  (e) =>
                                    e.language_code ==
                                    productDetail?.language_code
                                )
                              )
                            }
                            value={items.description}
                          />
                        </div>
                      </div>
                      <div className="col-md-1">
                        <div
                          className="form-group"
                          style={{
                            paddingTop: "40px",
                            paddingInlineStart: "10px",
                          }}
                        >
                          {productUps[index] &&
                            (!approval_status ||
                              approval_status == "NOT SUBMITTED" ||
                              approval_status == "REJECTED" ||
                              approval_status == "COMPLETED" ||
                              (approval_status == "ONREVISED" &&
                                next_step_nik_detail == userInfo.nik)) && (
                              <a
                                type="button"
                                className="btn btn-danger"
                                style={{ width: 50 }}
                                onClick={() => removeRowUsp(index)}
                              >
                                <i className="fa fa-trash" />{" "}
                              </a>
                            )}
                        </div>
                      </div>
                      {/* <div className="col-md-1">
                        <div
                          className="form-group"
                          style={{
                            paddingTop: "40px",
                            paddingInlineStart: "10px",
                          }}
                        >
                          <a
                            type="button"
                            className={
                              !approval_status ||
                              approval_status == "NOT SUBMITTED" ||
                              approval_status == "COMPLETED" ||
                              (approval_status == "ONREVISED" &&
                                next_step_nik_detail == userInfo.nik)
                                ? "btn btn-warning"
                                : "disabled btn btn-warning"
                            }
                            style={{ width: 50 }}
                            onClick={() => resetRowUsp(index)}
                          >
                            <i className="fa fa-undo" />{" "}
                          </a>
                        </div>
                      </div> */}
                    </div>
                  ))}
              </div>
              <Modal
                id={modalId5 + index}
                title="Image Description"
                onClose={(e) => onCloseModal5(e, index)}
                modalSize="modal-lg"
              >
                <div className="col-md-12">
                  <div className="form-group">
                    <label htmlFor="file_name">Image Name</label>
                    <input
                      name="file_name"
                      value={item.name}
                      className="form-control"
                      disabled={true}
                    />
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="form-group">
                    <label htmlFor="description">Image Description</label>
                    {productUps[index] ? (
                      <input
                        type="text"
                        name="description"
                        value={item.media_desc}
                        onChange={(e) => onDescChangeUsp(e, index)}
                        className="form-control"
                      />
                    ) : (
                      <input
                        type="text"
                        name="description"
                        value=""
                        onChange={(e) => onDescChangeUsp(e, index)}
                        className="form-control"
                      />
                    )}
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="media_types">Image Type</label>
                      {media_types.length > 0 &&
                        media_types.map((itemDesc) => (
                          <div
                            key={itemDesc.code}
                            onClick={() =>
                              onAddFileDescModalUsp(
                                index,
                                itemDesc.code,
                                "media_types"
                              )
                            }
                            className={
                              productUps[index] &&
                                item.media_type.indexOf(itemDesc.code) > -1
                                ? "bg-orange"
                                : "bg-white"
                            }
                            style={{
                              border: "1px solid #ccc",
                              marginBottom: 5,
                              padding: 5,
                              borderRadius: 5,
                              cursor: "pointer",
                            }}
                          >
                            {itemDesc.name}
                          </div>
                        ))}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="content_types">Content Type</label>
                      {content_types.length > 0 &&
                        content_types.map((itemContent) => (
                          <div
                            key={itemContent.code}
                            onClick={() =>
                              onAddFileDescModalUsp(
                                index,
                                itemContent.code,
                                "content_types"
                              )
                            }
                            className={
                              productUps[index] &&
                                item.content_type.indexOf(itemContent.code) > -1
                                ? "bg-orange"
                                : "bg-white"
                            }
                            style={{
                              border: "1px solid #ccc",
                              marginBottom: 5,
                              padding: 5,
                              borderRadius: 5,
                              cursor: "pointer",
                            }}
                          >
                            {itemContent.name}
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </Modal>
            </div>
          )
        }
        )
      }
      {productDetail?.language_code &&
        (!approval_status ||
          approval_status == "NOT SUBMITTED" ||
          approval_status == "COMPLETED" ||
          approval_status == "REJECTED" ||
          (approval_status == "ONREVISED" &&
            next_step_nik_detail == userInfo.nik)) && (
          <div className="row" style={{ margin: "10px" }}>
            <div className="col-md-3">
              <p
                style={{ cursor: "pointer" }}
                onClick={() => addRowUps(productUps.length)}
              >
                {" "}
                + Add USP Product{" "}
              </p>
            </div>
          </div>
        )}
      <div className="col-md-12">
        <div className="form-group">
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              marginTop: 16,
            }}
          >
            {productDetail?.language_code && (
              <div className="col-md-12">
                <div className="form-group">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      marginTop: 16,
                    }}
                  >
                    {/* <div style={{ width: 100 }}>
                                            <button type="button" className="btn btn-block btn-dark" onClick={onUpsSave}>
                                                <i className='fa fa-save' ></i> Draft
                                            </button>
                                        </div> */}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductUspHighlight;
